import React, { FC } from 'react';

import { useCurrentUser, usePageNavs }          from '../../../hooks';
import { GenericNav, GenericNavComponentProps } from './GenericNav';
import { MenuProps }                            from 'semantic-ui-react';

interface Props extends Omit<MenuProps, 'className'>, Partial<GenericNavComponentProps> {}

const UserAccountNav: FC<Props> = ( props ) => {
	
	let { currentUser }                   = useCurrentUser(),
	    { generateUserAccountSectionNav } = usePageNavs();
	
	let navObjects = generateUserAccountSectionNav();
	
	return (
		
		<GenericNav withParent={ false } navObjects={ navObjects } { ...props }/>
	);
};

UserAccountNav.defaultProps = {};

export { UserAccountNav }
